import { Box, Typography } from "@mui/material";
import { ReactElement } from "react";
import { useTranslation } from "react-i18next";

interface IErrorDisplayUnsavedItemsProps {
  unsavedItemText?: string;
  callToActionText?: string;
}

export const ErrorDisplayUnsavedItems = ({
  unsavedItemText = `general.UNSAVED_CONFIRMATION.UNSAVED_ITEMS`,
  callToActionText = `general.UNSAVED_CONFIRMATION.CONFIRM_MSG`,
}: IErrorDisplayUnsavedItemsProps): ReactElement => {
  const { t } = useTranslation();

  return (
    <Box sx={{ py: 2 }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        {unsavedItemText && <Typography>{t(unsavedItemText)}</Typography>}
      </Box>
      <Typography>{t(callToActionText)}</Typography>
    </Box>
  );
};
